import { Type } from "@angular/core";

import { ObgCurrencyPipe } from "./currency/obg-currency.pipe";

export const I18N_PIPES: Type<unknown>[] = [ObgCurrencyPipe];
